<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12 text-center">
        <h6 class="text-muted">Redirecting...</h6>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { onMounted } from 'vue'

const router = useRouter()

onMounted(() => {
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  const roles = user.roles || []
  // Si tu stockes le code du poste, tu peux faire includes('RRH') ici
  if (roles.includes('admin') || roles.includes('SuperAdmin') || roles.includes('manager') || roles.includes('RRH')) {
    router.replace('/employee/loans/review')
  } else {
    router.replace('/employee/loans/request')
  }
})
</script>
